<template>

    <div :class="{ 'dark': store.state.global.isDark }">

        <Head title="Log in" />

        <jet-authentication-card>
            <template #logo>
                <Link class="block w-full py-4" method="get" :href="route('dashboard')">
                    <span v-if="$page.props.settings.site_name ==='Racing Stars'">
                        <img :src="'/images/logo.png'" alt="">
                    </span>

                    <span v-else-if="$page.props.settings.site_name ==='Racing League'">
                        <img :src="'/images/racingleague/racingleague-live.png'" alt="">
                    </span>
                    
                    <span v-else-if="$page.props.settings.site_name ==='Zilliqa'">
                        <img :src="'/images/logos/twc-the-game.png'" alt="">
                    </span>

                    <span v-else>
                       <jet-authentication-card-logo />
                </span>
                </Link>
            </template>
            <jet-validation-errors class="mb-4" />
            <div v-if="status" class="mb-4 font-medium text-sm text-green-600">
                {{ status }}
            </div>
            <form @submit.prevent="submit">
                <div>
                    <jet-label :ignore-dark-mode="true" for="email" value="Username or Email" />
                    <jet-input :ignore-dark-mode="true" id="email" type="text" class="mt-1 block w-full" v-model="form.email" required autofocus autocomplete="email" />
                </div>
                <div class="mt-4">
                    <div class="flex justify-between text-sm text-sm text-gray-700 transition">
                        <jet-label :ignore-dark-mode="true" for="password" value="Password" />
                        <a v-if="canResetPassword" :href="route('password.request')" class="text-sm text-gray-600 hover:text-gray-900">
                            Forgot your password?
                        </a>
                    </div>
                    <jet-input :ignore-dark-mode="true" id="password" type="password" class="mt-1 block w-full" v-model="form.password" required autocomplete="current-password" />

                </div>
                <div class="block mt-4">
                    <label class="flex items-center">
                        <jet-checkbox :ignore-dark-mode="true" name="remember" v-model:checked="form.remember" />
                        <span class="ml-2 text-sm text-gray-600">Remember me</span>
                    </label>
                </div>
                <div class="flex items-center justify-center mt-4 relative">
                    <jet-button :class="{ 'opacity-25': form.processing }" :disabled="form.processing" class="
                    !block w-full text-gray-600 bg-racing-stars-yellow
                    hover:bg-[#4285F4]/90 focus:ring-4 focus:outline-none focus:ring-[#4285F4]/50 font-medium rounded-lg text-sm px-5 py-2.5 text-center
                     items-center dark:focus:ring-[#4285F4]/55 mr-2 mb-2
">
                        Log in
                    </jet-button>
                </div>
                <div class="relative my-6">
                    <div class="absolute inset-0 flex items-center">
                        <div class="w-full border-t border-gray-300"></div>
                    </div>
                    <div class="relative flex justify-center text-sm"><span class="px-2 text-gray-500 bg-white">Or</span></div>
                </div>
                <div v-if="$page.props.settings.site_name == 'Racing Stars'" class="flex flex-col sm:flex-row items-center justify-center mt-4 relative">
                        <a href="/auth/google">
                            <button type="button" class="
                            mr-2 text-white bg-[#4285F4] border-[1px] border-[#4285F4] hover:bg-[#4285F4]/90 focus:ring-4 focus:outline-none focus:ring-[#4285F4]/50
                             font-medium text-sm text-center rounded-sm inline-flex items-center dark:focus:ring-[#4285F4]/55
                             mb-2"
                            >
                                <img :src="asset('images/google_logo.png')" class="bg-white"/>
                                <p class="px-2 text-sm font-medium" style="font-family: 'Roboto', sans-serif;">
                                    Sign in with Google
                                </p>

                            </button>
                        </a>
                    <a href="/auth/facebook">
                        <button type="button" class="text-white bg-[#3b5998] hover:bg-[#3b5998]/90 focus:ring-4 focus:outline-none focus:ring-[#3b5998]/50 font-medium rounded-sm text-sm px-5 py-2 text-center inline-flex items-center dark:focus:ring-[#3b5998]/55 mr-2 mb-2">
                            <svg class="w-4 mr-3" aria-hidden="true" focusable="false" data-prefix="fab" data-icon="facebook-f" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path fill="currentColor" d="M279.1 288l14.22-92.66h-88.91v-60.13c0-25.35 12.42-50.06 52.24-50.06h40.42V6.26S260.4 0 225.4 0c-73.22 0-121.1 44.38-121.1 124.7v70.62H22.89V288h81.39v224h100.2V288z"></path></svg>
                            Sign in with Facebook
                        </button>
                    </a>
                </div>

                <div class="flex items-center justify-center mt-4 text-gray-600">
                    Not yet a user?
                    <Link :href="route('register')" class="underline text-sm text-gray-600 hover:text-gray-900 ml-3">
                        Sign Up
                    </Link>
                </div>
            </form>
        </jet-authentication-card>
    </div>

</template>
<script>


import JetAuthenticationCard from '@/Jetstream/DefaultAuthenticationCard.vue'
import JetAuthenticationCardLogo from '@/Jetstream/AuthenticationCardLogo.vue'
import JetButton from '@/Jetstream/Button.vue'
import JetInput from '@/Jetstream/Input.vue'
import JetCheckbox from '@/Jetstream/Checkbox.vue'
import JetLabel from '@/Jetstream/Label.vue'
import JetValidationErrors from '@/Jetstream/ValidationErrors.vue'
import { Head, Link } from '@inertiajs/inertia-vue3';
import { getCurrentInstance } from 'vue';
import { useStore } from 'vuex'
import { Inertia } from '@inertiajs/inertia'
import ApplicationLogo from '@/Jetstream/ApplicationLogo'
import Popper from "vue3-popper";
export default {
    components: {
        Popper,
        Head,
        JetAuthenticationCard,
        JetAuthenticationCardLogo,
        JetButton,
        JetInput,
        JetCheckbox,
        JetLabel,
        JetValidationErrors,
        Link,
        Inertia,
        ApplicationLogo
    },

    props: {
        canResetPassword: Boolean,
        status: String
    },

    setup() {


        /**
         * The VueX store.
         *
         * @type {Object}
         */
        const store = useStore()

        const code = route().params.code

        const form = Inertia.form({
            email: '',
            password: '',
            remember: false
        })

        const submit = () => {
            form
                .transform(data => ({
                    ...data,
                    remember: form.remember ? 'on' : ''
                }))
                .post(route('login'), {
                    onFinish: () => {
                        form.reset('password')

                        if (code) {
                            Inertia.get(route('leagues.show', code))
                        }
                    },
                })
        }

        return {
            code,
            submit,
            form,
            store,
        }

    }
}

</script>
